import { render } from "./ProfilItem.vue?vue&type=template&id=9b28cb98"
import script from "./ProfilItem.vue?vue&type=script&lang=js"
export * from "./ProfilItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__